import { t } from "i18next";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmUploadStore } from "../MdmUploadStore";
import * as styles from "./UploadInfo.module.less";

type PropsUploadInfo = {
  store: MdmUploadStore;
};

export const UploadInfo: React.FC<PropsUploadInfo> = observer(({ store }) => {
  const { maxCount, accept, maxSize } = store;
  return (
    <div className={styles.uploadInfo}>
      {accept && <div>{t("Format: value", { value: accept })}</div>}
      {maxCount && <div>{t("Maximum number: count", { count: maxCount })}</div>}
      {maxSize && <div>Максимальный размер файла: {maxSize} МБ</div>}
    </div>
  );
});
